exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bless-image-button>.MuiButton-label{position:relative;width:24px;height:28px;display:flex;align-items:center;justify-content:center}.bless-image-button:hover .bless-image-button__icon{color:#fa6422}.bless-image-button__icon{position:absolute;z-index:1;margin:0;padding:0;width:100%;height:100%}.bless-image-button__action-icon{border-radius:100%;background:#fff;font-size:16px;font-size:1rem;position:absolute;right:-4px;top:-4px;z-index:2}@media (prefers-color-scheme: dark){:root:not([data-theme=light]):not([data-theme=dark]) .bless-image-button__action-icon{background:#000}}:root[data-theme=dark] .bless-image-button__action-icon{background:#000}.bless-image-button__action-icon-check{color:darkolivegreen}.bless-image-button__action-icon-cancel{color:indianred}\n", ""]);

// exports
exports.locals = {
	"bless-image-button": "bless-image-button",
	"MuiButton-label": "MuiButton-label",
	"bless-image-button__icon": "bless-image-button__icon",
	"bless-image-button__action-icon": "bless-image-button__action-icon",
	"bless-image-button__action-icon-check": "bless-image-button__action-icon-check",
	"bless-image-button__action-icon-cancel": "bless-image-button__action-icon-cancel"
};